import type { TaskWhisper } from '@frontend/api-types';
import type { RichWhisperProps } from '@frontend/react-domain';
import { Text, YStack } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';
import { type ComponentType, useEffect } from 'react';

export const withWhisperAccordion = <W extends TaskWhisper>(
  Inner?: ComponentType<{ whisper: W }>,
): ComponentType<RichWhisperProps> => {
  const Wrapped = ({ commentId, taskId, whisper }: RichWhisperProps) => {
    const { track } = useAnalytics();

    useEffect(() => {
      if (!commentId || !taskId) return;
      track({
        data: { commentId, source: 'rich', taskId, whisperType: whisper.type },
        event: 'whisperRendered',
        topic: 'whispers',
      });
    }, [commentId, taskId, whisper.type]);

    const verticalPadding = Inner ? 'py-[6px]' : 'py-[3px]';
    return (
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
      <YStack className={`self-start rounded-md border-1 border-cream-100 bg-cream-50 ${verticalPadding} px-[10px]`}>
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <Text className="text-[12px] text-neutral-700" style={{ fontFamily: 'Geist' }}>
          {whisper.title}
        </Text>
        {Inner ? <Inner whisper={whisper as W} /> : null}
      </YStack>
    );
  };
  const innerName = Inner?.displayName ?? Inner?.name;
  // eslint-disable-next-line fp/no-mutation
  Wrapped.displayName = innerName ? `WhisperAccordion(${innerName})` : 'WhisperAccordion';
  return Wrapped;
};
